import React, { useState, useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import {
  Alert,
  Box,
  Button,
  Divider,
  FormLabel,
  OutlinedInput,
  Paper,
  Typography,
} from '@mui/material';

import { callApi } from 'utils';
import { Page } from 'components';
import { t } from 'i18n';

const lineStyle = {
  color: '#546e7a',
  display: 'inline-block',
  textAlign: 'right',
  marginRight: '8px',
  width: '7em',
};
const DataLine = ({name, value}) => (
  <Typography sx={{my: 0.5}}>
    <span style={lineStyle}>{name}:</span>
    {value}
  </Typography>
);

const FieldData = () => {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const spid = searchParams.get('id') || '';
  const [res, setRes] = useState({});
  const [id, setId] = useState(spid);
  const [loading, setLoading] = useState(false);

  const field = location.pathname.split('/').pop();
  useEffect(() => void(setRes({})), [field]);

  const handleQuery = () => {
    setSearchParams(prev => { prev.set('id', id); return prev; });
  };

  useEffect(() => {
    if (!spid) return;
    setLoading(true);
    callApi(`/jobs/${spid}/fields/${field}`).then((res) => {
      setRes(res);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [spid, field]);

  const { rows, error } = res;

  return (
    <Page title="Device Usage">
      <Paper sx={{p: 2, m: 2}}>
        <Box sx={{ my: 1, display: "flex", alignItems: "center" }}>
          <FormLabel gutterBottom>频控ID:</FormLabel>
          <OutlinedInput
            sx={{ml: 0.5, p: 0, width: 80}}
            name="id"
            value={id}
            size="small"
            inputProps={{ style: {padding: '6px'} }}
            onChange={(ev) => setId(ev.target.value)}
          />
          <Button
            color="primary"
            variant="outlined"
            size="small"
            onClick={handleQuery}
            disabled={loading}
            sx={{ mx: 0.5 }}
          >
            {loading ? "查询中" : "查询"}
          </Button>
        </Box>

        <Divider sx={{my: 2}} />

      {error && (<Alert severity="error">{t(error)}!</Alert>)}

      {rows && (
        <Box sx={{width: '100%'}}>
          {rows.map((row) => (<DataLine name={t(row.name)} value={row.value} key={row.name} />))}
        </Box>
      )}
      </Paper>
    </Page>
  );
};

export default FieldData;
